var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.value,"color":"grey"}},[_c('div',{staticClass:"d-flex flex-column align-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"primary"}}),_c('div',{staticClass:"title black--text ma-2"},[_vm._v(_vm._s(_vm.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }